<div class="accordion-container">
  <div class="header" (click)="isOpen = !isOpen">
    <span class="title">{{title}}</span>
    <img class="arrow-icon" src="../../../../assets/svgs/red_arrow_ico.svg" alt="arrow_ico" [ngClass]="{'--open': isOpen}">
  </div>
  <div class="accordion__content" [ngClass]="{'--open': isOpen, 'round-content': roundContent}">
    <ng-content></ng-content>
  </div>
</div>